import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Modal, Button } from '@sololearnorg/sol';
import { Container, StorageService, i18n } from '../../../../symphony';

import {
	SlLEContext,
	shouldShowTranslationWarningLSKey
} from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './TranslationWarning.scss';

export const TranslationWarning = () => {
	useStyles(s);
	const { actions$ } = Container.take(SlLEContext, SlActions);
	const [isOpen, setIsOpen] = useState(false);
	const { lessonStatus } = Container.take(SlLEContext, SlDataService);
	const { lesson$: lesson, course$: course } = useContainerData(
		SlLEContext,
		SlDataService,
		['lesson$', 'course$'],
	);
	const storageService = Container.take('global', StorageService);

	const closeHandler = () => {
		setIsOpen(false);
	};

	const okClickHandler = () => {
		closeHandler();
		actions$.next({
			type: ActionType.OnTranslationWarningCtaClick,
			requestType: RequestType.Parallel,
			data: {
				isTranslated: true,
			},
		});
	};

	useEffect(() => {
		if (!course || !lessonStatus) {
			return;
		}

		let shouldShowTranslationWarning: Record<string, boolean> = null;
		try {
			shouldShowTranslationWarning = JSON.parse(
				storageService.load(shouldShowTranslationWarningLSKey, 'local'),
			);
		} catch (error) {
			console.error(error);
		}

		if (shouldShowTranslationWarning?.[course.materialInfo.header.id]) {
			setIsOpen(true);
			storageService.save(
				shouldShowTranslationWarningLSKey,
				JSON.stringify(
					shouldShowTranslationWarningLSKey
						? {
							...shouldShowTranslationWarning,
							[course.materialInfo.header.id]: false,
						}
						: { [course.materialInfo.header.id]: false },
				),
				'local',
			);
		}
	}, [!!course, !!lessonStatus]);

	if (!isOpen) {
		return null;
	}

	return (
		<Modal.Default
			onClose={closeHandler}
			actions={[
				<Button buttonType="secondary" key={1} onClick={okClickHandler}>
					{i18n.t(
						`translate.tipkit.cta-test`,
					)}
				</Button>,
			]}
			headline={i18n.t(
				`translate.tipkit.title-test`,
			)}
			description={i18n.t(
				`translate.tipkit.description-test`,
			)}
			className="sl-translation-warning-modal"
		/>
	);
};
